module.exports = __webpack_public_path__ + "static/media/hp-cs-dennikN@2x.b88d1fab.png";